/* unplugin-vue-components disabled */import script from "./resetPwd.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPwd.vue?vue&type=script&setup=true&lang=js"

import "./resetPwd.vue?vue&type=style&index=0&id=73cfb65b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73cfb65b"]])

export default __exports__